import React from 'react';
import { staticURL } from 'core/url';
import { withNamespaces, Trans } from 'react-i18next';

import { useRouterStore, useClientStore } from 'apps/hooks';
import { useSharedFileManager } from 'apps/share/hooks';

import Heading from 'components/Heading';

import { EmptyChatWrapper, InviteLink } from './chat.styled';

const EmptyChat = () => {
  const { route } = useRouterStore();
  const sharedFileManager = useSharedFileManager();
  const clientStore = useClientStore();

  const isSharedFile = route.name.includes('shared');

  let isSharedFileAdmin = false;
  if (sharedFileManager && sharedFileManager.sharedFile) {
    const { sharedFile } = sharedFileManager;
    sharedFile.groups.forEach(group => {
      if (group.name === 'admin') {
        group.members.forEach(member => {
          if (
            member.profile.username === clientStore.signedInProfile?.username
          ) {
            isSharedFileAdmin = true;
          }
        });
      }
    });
  }
  let ctaTitle = 'Your CAD review starts here!';
  let ctaDescription =
    'Leave a message or place a 3D annotation to get started.';
  if (route.name === 'rfq') {
    ctaTitle = 'Your RFQ discussion starts here.';
    ctaDescription = 'Leave a message or place a 3D annotation to get started.';
  }
  if (route.name === 'order') {
    ctaTitle = 'Your Order conversation starts here.';
    ctaDescription = 'Leave a message or place a 3D annotation to get started.';
  }

  return (
    <EmptyChatWrapper>
      <img
        src={staticURL('assets/chat/empty_chat.svg')}
        alt='Empty Chat Module'
        width='181'
        height='128'
      />
      <Heading level='3' size='medium' align='center' margin='small'>
        <Trans>{ctaTitle}</Trans>
      </Heading>
      <Heading
        level='4'
        size='small'
        weight='regular'
        align='center'
        margin='0 large'
      >
        <Trans>
          {ctaDescription}
          {isSharedFile && isSharedFileAdmin && (
            <>
              {' '}
              Be sure to{' '}
              <InviteLink
                onClick={() => sharedFileManager.SetUserSettingsOpen(true)}
              >
                invite your collaborators
              </InviteLink>{' '}
              too!
            </>
          )}
        </Trans>
      </Heading>
    </EmptyChatWrapper>
  );
};

export default withNamespaces()(EmptyChat);
